// Script to handle header transparency based on scroll position
(function() {
  'use strict';
  
  // Get the video section element
  const videoSection = document.querySelector('.shopify-section-template--25098317267268__videobanner_CQN8Jd') || 
                       document.querySelector('[class*="videobanner"]') ||
                       document.querySelector('video')?.closest('section') ||
                       document.querySelector('video')?.closest('.shopify-section');
  
  // Only enable transparent header styles if video section exists
  if (!videoSection) {
    return; // Exit silently if no video section found
  }
  
  // Add data attribute to enable transparent header styles
  document.body.setAttribute('data-has-video-header', 'true');
  
  // Function to toggle header background based on scroll position
  function handleScroll() {
    if (!videoSection) {
      return;
    }
    
    // Get the bottom position of the video section
    const videoBottom = videoSection.offsetTop + videoSection.offsetHeight;
    const scrollPosition = window.scrollY || window.pageYOffset;
    
    // Add offset to trigger transition earlier (before fully past video)
    const offset = 50; // Adjust this value to fine-tune when header changes
    
    // Add or remove class based on scroll position
    if (scrollPosition > (videoBottom - offset)) {
      document.body.classList.add('scrolled-past-video');
    } else {
      document.body.classList.remove('scrolled-past-video');
    }
  }
  
  // Run on page load
  handleScroll();
  
  // Run on scroll with throttling for better performance
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  // Run on window resize (in case video height changes)
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleScroll, 150);
  });
  
  // Re-check after images/videos load
  window.addEventListener('load', handleScroll);
  
})();